import { z } from "../../wire/zod";

export const canConnectResponseSchema = z.object({ canConnect: z.boolean() });
export const checkAllJiraProjectPermissionsForArtResponseSchema = z.object({
  artsWithMissingPermissions: z.array(z.number().int()),
  checked: z.boolean(),
});
export const checkJiraIssueTypeFieldsResponseSchema = z.object({
  projects: z.array(
    z.object({
      project: z.string(),
      creatable: z.boolean(),
      fields: z.array(
        z.object({ name: z.string(), available: z.boolean(), required: z.boolean() }),
      ),
    }),
  ),
});
export const checkJiraIssueTypeForArtsResponseSchema = z.object({
  projects: z.array(
    z.object({ projectId: z.string(), projectName: z.string(), hasSummary: z.boolean() }),
  ),
});
export const checkJiraLinkTypeResponseSchema = z.object({
  fromErrors: z.array(
    z.object({ project: z.union([z.string(), z.null()]).optional(), error: z.string() }),
  ),
  toErrors: z.array(
    z.object({ project: z.union([z.string(), z.null()]).optional(), error: z.string() }),
  ),
});
export const checkJiraProjectPermissionsForArtResponseSchema = z.object({
  projectId: z.string(),
  missingPermissions: z.array(
    z.object({ name: z.string(), required: z.boolean(), error: z.string() }),
  ),
});
export const checkJiraProjectPermissionsResponseSchema = z.object({
  projectId: z.string(),
  permissionsOkay: z.boolean(),
  missingPermissions: z.array(
    z.object({ name: z.string(), required: z.boolean(), error: z.string() }),
  ),
});
export const checkJiraTeamMappingsResponseSchema = z.object({
  erroredTeams: z.array(z.number().int()),
  checked: z.boolean(),
});
export const createJiraSyncSessionResponseSchema = z.object({ syncSessionId: z.string() });
export const createJiraTestIssueResponseSchema = z.object({
  issueKey: z.string(),
  url: z.string(),
});
export const getJiraArtFieldMappingFormattedResponseSchema = z.object({
  mapping: z
    .union([
      z.object({
        fieldId: z.string().optional(),
        schema: z.record(z.string(), z.any()).optional(),
        values: z.record(z.string(), z.string()).optional(),
      }),
      z.null(),
    ])
    .optional(),
});
export const getJiraArtFieldMappingResponseSchema = z.object({
  mapping: z
    .union([
      z.object({
        fieldId: z.string().optional(),
        schema: z.record(z.string(), z.any()).optional(),
        values: z.record(z.string(), z.any()).optional(),
      }),
      z.null(),
    ])
    .optional(),
});
export const getJiraArtTeamFieldMappingFieldsResponseSchema = z.object({
  fields: z.array(
    z.object({
      id: z.string(),
      key: z.string(),
      name: z.string(),
      projectIds: z.array(z.string()),
      schema: z.record(z.string(), z.any()).optional(),
      warnings: z.array(z.string()),
    }),
  ),
});
export const getJiraArtTeamFieldMappingFormattedResponseSchema = z.object({
  mapping: z
    .union([
      z.object({
        fieldId: z.string().optional(),
        schema: z.record(z.string(), z.any()).optional(),
        values: z.record(z.string(), z.string()).optional(),
      }),
      z.null(),
    ])
    .optional(),
});
export const getJiraArtTeamFieldMappingResponseSchema = z.object({
  mapping: z
    .union([
      z.object({
        fieldId: z.string().optional(),
        schema: z.record(z.string(), z.any()).optional(),
        values: z.record(z.string(), z.any()).optional(),
      }),
      z.null(),
    ])
    .optional(),
});
export const getJiraAuthMethodResponseSchema = z.object({
  authMethod: z.enum(["basic-auth", "oauth1", "cloud-service-account-token"]),
});
export const getJiraBoardMappingResponseSchema = z.object({
  mapping: z.array(
    z.object({
      userId: z.number().int(),
      sources: z.array(
        z.object({
          id: z.number().int(),
          boardId: z.number().int(),
          projectId: z.string(),
          name: z.string().optional(),
          teamFields: z.array(z.record(z.string(), z.any())),
          defaultFields: z.string().optional(),
          defaultIssueTypeId: z.string().optional(),
        }),
      ),
    }),
  ),
});
export const getJiraCustomEpicIssueTypeResponseSchema = z.object({
  issueTypeId: z.union([z.string(), z.null()]).optional(),
});
export const getJiraEpicIssueTypeResponseSchema = z.object({
  issueType: z.union([z.record(z.string(), z.any()), z.null()]).optional(),
});
export const getJiraFieldsResponseSchema = z.object({
  fields: z.array(z.record(z.string(), z.any())),
});
export const getJiraIssueLinkTypesResponseSchema = z.object({
  linkTypes: z.array(z.record(z.string(), z.any())),
});
export const getJiraIssueTypesResponseSchema = z.object({
  issueTypes: z.array(z.record(z.string(), z.any())),
});
export const getJiraKanbanBoardResponseSchema = z.object({
  boardId: z.union([z.number().int(), z.null()]).optional(),
});
export const getJiraKanbanConfigsResponseSchema = z.object({
  configs: z.record(
    z.string(),
    z.array(
      z.object({
        name: z.string(),
        columns: z.array(z.object({ name: z.string(), statuses: z.array(z.string()) })),
      }),
    ),
  ),
});
export const getJiraOAuthConsumerKeyResponseSchema = z.object({ consumerKey: z.string() });
export const getJiraOAuthPublicKeyResponseSchema = z.object({ publicKey: z.string() });
export const getJiraOAuthUrlResponseSchema = z.object({ url: z.string() });
export const getJiraProjectsResponseSchema = z.object({
  projects: z.array(z.record(z.string(), z.any())),
});
export const getJiraSessionBacklogFieldsResponseSchema = z.object({
  fields: z.array(
    z.object({
      id: z.string(),
      key: z.string(),
      name: z.string(),
      projectIds: z.array(z.string()),
      schema: z.record(z.string(), z.any()).optional(),
      warnings: z.array(z.string()),
    }),
  ),
});
export const getJiraSessionTeamFieldMappingFormattedResponseSchema = z.object({
  mapping: z
    .union([
      z.object({
        fieldId: z.string().optional(),
        schema: z.record(z.string(), z.any()).optional(),
        values: z.record(z.string(), z.string()).optional(),
      }),
      z.null(),
    ])
    .optional(),
});
export const getJiraSessionTeamFieldMappingResponseSchema = z.object({
  mapping: z
    .union([
      z.object({
        fieldId: z.string().optional(),
        schema: z.record(z.string(), z.any()).optional(),
        values: z.record(z.string(), z.any()).optional(),
      }),
      z.null(),
    ])
    .optional(),
});
export const getJiraSprintResponseSchema = z.object({
  sprint: z.union([z.record(z.string(), z.any()), z.null()]).optional(),
});
export const getJiraSprintsResponseSchema = z.object({
  sprints: z.array(z.record(z.string(), z.any())),
});
export const getJiraSyncSessionResponseSchema = z.object({
  session: z.union([z.record(z.string(), z.any()), z.null()]).optional(),
});
export const getJiraTeamDefaultFieldsResponseSchema = z.object({
  fields: z.array(
    z.object({
      id: z.string(),
      key: z.string(),
      name: z.string(),
      projectIds: z.array(z.string()),
      schema: z.record(z.string(), z.any()).optional(),
      warnings: z.array(z.string()),
    }),
  ),
});
export const getJiraTeamMappingFieldsResponseSchema = z.object({
  fields: z.array(
    z.object({
      id: z.string(),
      key: z.string(),
      name: z.string(),
      projectIds: z.array(z.string()),
      schema: z.record(z.string(), z.any()).optional(),
      warnings: z.array(z.string()),
    }),
  ),
});
export const getJiraTeamMappingSourcesFormattedResponseSchema = z.object({
  sources: z.array(
    z.object({
      id: z.number().int().optional(),
      boardId: z.number().int(),
      projectId: z.string(),
      name: z.string().optional(),
      teamFields: z.string(),
      defaultFields: z.string().optional(),
      defaultIssueTypeId: z.string().optional(),
    }),
  ),
});
export const getJiraUsernameResponseSchema = z.object({ username: z.string() });
export const getJiraWebhookEndpointResponseSchema = z.object({ webhookUrl: z.string() });
export const noDataSchema = z.record(z.string(), z.never());
